import type { AxiosError } from 'axios';

interface ApiErrorPayload {
  code?: string;
  errorCode?: string;
  message?: string;
}

const isObject = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null;

export const getApiErrorPayload = (error: AxiosError): ApiErrorPayload | undefined => {
  const data = error.response?.data;
  return isObject(data) ? (data as ApiErrorPayload) : undefined;
};

const SCORE_VALIDATION_FAILED = 'SCORE_VALIDATION_FAILED';

/**
 * 설문 서버의 채점 문항 오류(422 + SCORE_VALIDATION_FAILED)에서 문항 번호 목록을 꺼낸다.
 * null·빈 문자열 라벨은 빼고 순서를 유지해 중복을 제거한다. 남는 번호가 없거나 다른 오류면 undefined.
 */
export const getScoreValidationLabels = (error: unknown): string[] | undefined => {
  const response = isObject(error) ? error.response : undefined;
  if (!isObject(response) || response.status !== 422) {
    return undefined;
  }
  const data = response.data;
  if (!isObject(data) || data.code !== SCORE_VALIDATION_FAILED || !Array.isArray(data.errors)) {
    return undefined;
  }
  const labels = data.errors
    .map((e) => (isObject(e) ? e.label : undefined))
    .filter((label): label is string => typeof label === 'string' && label !== '');
  const unique = [...new Set(labels)];
  return unique.length > 0 ? unique : undefined;
};
